import { PreloaderHandlerInterface } from './webglLoadingHandler';
import { EnableSoundCommand } from '../clientCommands/enableSoundCommand';
import { GameClient } from '../gameClient';


export class NewgameWebglLoadingHandler implements PreloaderHandlerInterface {
    private hasEnabled = false;

    onCompatibilityCheckFailed(): void {
        return undefined;
    }

    onPreStart(_initialPercents: number): void {
        return undefined;
    }

    onClientLoadingProgressChanged(_clientLoadingPercent: number): void {
        if (!this.hasEnabled) {
            GameClient.getInstance().sendCommand(new EnableSoundCommand());
            this.hasEnabled = true;
        }
    }

    onCompileProgressChange(_compileProgressShare: number): void {
        return undefined;
    }
}
